export default __webpack_public_path__ + "static/media/Lava-Noise-0.1.71e6a540.jpg";